var map = {
	"./active-archie.svg": 97506,
	"./inactive-archie.svg": 71411,
	"./logo-archie.svg": 4651,
	"./logo-edd.svg": 64468,
	"./logo-google-analytics.svg": 24180,
	"./logo-om.svg": 56919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;